import { Button, CommandButton, DefaultButton, FontWeights, getTheme, IconButton, mergeStyleSets, Modal, Stack } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import * as React from 'react';
import { IImageThumbnail } from '../../../Models/PhotoGallery/IImageThumbnail';
import { backendUrl } from '../../../Services/ConfigureService';
import ProgressiveImg from './ProgressiveImg ';
import './styles.css'
interface IPhotogalleryViewProps {
    images: IImageThumbnail[]
    startIndex: number;
    onDismiss: () => void;
}

export const PhotogalleryView: React.FC<IPhotogalleryViewProps> = props => {

    const [index, setIndex] = React.useState<number>(props.startIndex);
    const titleId = useId('title');
    const theme = getTheme();

   
    const contentStyles = mergeStyleSets({
        container: {
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch',
        },
        header: [            
            theme.fonts.xLargePlus,
            {
                flex: '1 1 auto',
                borderTop: `4px solid ${theme.palette.themePrimary}`,
                color: theme.palette.neutralPrimary,               
                display: 'flex',
                alignItems: 'center',
                fontWeight: FontWeights.semibold,
                padding: '12px 12px 14px 24px',
            },
        ],
        heading: {
            color: theme.palette.neutralPrimary,
            fontWeight: FontWeights.semibold,
            fontSize: 'inherit',
            margin: '0',
        },
        body: {
            background: theme.palette.black,
            flex: '4 4 auto',
            padding: '0 24px 24px 24px',
            overflowY: 'hidden',
            selectors: {
                p: { margin: '14px 0' },
                'p:first-child': { marginTop: 0 },
                'p:last-child': { marginBottom: 0 },
            },
        },
    });

    const renderImage = (images: IImageThumbnail[], index: number) => {
        return <ProgressiveImg placeholderSrc={`${backendUrl()}api/PhotoGallery/GeImageThumbnailById/${images[index].id}`} src={`${backendUrl()}api/PhotoGallery/GeImageById/${images[index].id}`} style={{ maxHeight: '100%', maxWidth: '100%', height: 'auto', objectFit: 'contain' }} alt={''} /> 
    }

    const next = () => {
        if (index < props.images.length-1) {
            setIndex(index + 1);
        }
        else {
            setIndex(0);
        }
    }
    const before = () => {
        if (index > 0 ) {
            setIndex(index - 1);
        }
        else {
            setIndex(props.images.length-1);
        }
    }
 
    return (
        <Modal
            titleAriaId={titleId}
            isOpen={true}
            onDismiss={props.onDismiss}
            isBlocking={false}
            scrollableContentClassName="scrollableContentClassName"
            containerClassName={contentStyles.container}>
            <div className={contentStyles.body}>
                <Stack horizontal styles={{ root: { width: 'calc(100%)', height: '100%' } }}>
                    <Stack verticalAlign="center" styles={{ root: { height: '100vh', paddingRight: 20 } }} >
                        <CommandButton iconProps={{ iconName: "Previous", color: "white" }} styles={{ root: { color: "white" }, icon: { color: "white", fontSize:36 } }} onClick={before} />
                </Stack>
                <Stack styles={{ root: { height: '100vh' } }} verticalAlign="center">
                    {renderImage(props.images, index)}
                </Stack>
                    <Stack verticalAlign="center" styles={{ root: { height: '100vh', paddingLeft: 20 } }}>                        
                        <CommandButton iconProps={{ iconName: "Next", color: "white" }} styles={{ root: { color: "white" }, icon: { color: "white", fontSize: 36 } }} onClick={before} />
                </Stack>
                </Stack>
            </div>
        </Modal>
            )
}